<template>
    <CRow>
        <CCol col>

            <div style="width:100%; height: 80vh;">
                <ejs-grid ref='grid' :dataSource="groupData" :allowFiltering='true' :commandClick='commandClick' :allowPaging="true" :enablePersistence ="true" :allowResizing='true' :toolbarClick='toolbarClick' :allowExcelExport='true' :excelExportComplete='excelExportComplete' :allowReordering='true' :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar' :pageSettings='pageSettings' :actionComplete='actionComplete' :actionBegin="actionBegin" :actionFailure="actionFailure" :filterSettings='filterOptions'
                          :recordDoubleClick="recordDoubleClick" width="100%" height="100%" :dataBound="dataBound">
                    <e-columns>
                        <e-column field='id' headerText='Id' :isPrimaryKey='true' :visible='false' type="number"></e-column>
                        <e-column field='name' headerText='Report Template Name' width=300 :validationRules="requiredRules" type="string"></e-column>
                        <e-column field='type' headerText='Type' :validationRules="requiredRules" type="string"></e-column>
                        <e-column field='createdBy' headerText='Created By' :validationRules="requiredRules" type="string"></e-column>
                        <e-column field='clientName' headerText='Client/ATG Name' :validationRules="requiredRules" type="string"></e-column>
                        <e-column field='contractName' headerText='Contract Name' :validationRules="requiredRules" type="string"></e-column>
                        <e-column field='startDate' headerText='Start Date' :validationRules="requiredRules" :format='dateFormatOptions' type='date'></e-column>
                        <e-column field='generationFrequencyName' headerText='Frequency' :validationRules="requiredRules" type="string"></e-column>
                        <e-column field='nextScheduledDate' headerText='Next Scheduled Run' :validationRules="requiredRules" :format='dateFormatOptions' type='date'></e-column>
                        <e-column headerText='Actions' textAlign='left' width=100 :commands='commands'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </CCol>
    </CRow>
</template>
<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn } from "@syncfusion/ej2-vue-grids";
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../common/syncfusion';
    import apis from '../../common/network'
    import urls from '../../common/urls'
    import gridOptions from '../../common/gridOptions'
    import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import Router from 'vue-router'
    import store from '../../store';
    import router from '../../router';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(Router)
    Vue.use(ButtonPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(DialogUtility);

    Vue.use(GridPlugin);
    let AlertDialog;

    export default {
        name: 'reportsForm',
        components: {
        },
        data() {
            return {
                store: store,
                router: router,
                groupData: SyncHelper.getDataManager("ReportTemplate"),
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy' },
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                  
                    mode: 'Dialog'
                }, toolbar: [{ text: 'Add', tooltipText: 'Add', prefixIcon: 'e-add', id: 'AddReportTemplate'  },
                    { text: 'Edit', tooltipText: 'Edit', prefixIcon: 'e-edit', id: 'EditReportTemplate'  },
                    { text: 'Delete', tooltipText: 'Delete', prefixIcon: 'e-delete', id: 'DeleteReportTemplate'}, 'ExcelExport'],

                requiredRules: { required: true, maxLength: 256 },
                editparams: { params: { popupHeight: '300px' } },
                filterOptions: gridOptions.filterSettings,
                commands: [{ buttonOption: { cssClass: 'e-primary', content: 'Run' } }],
            };
        },
        methods: {
            dataBound(args) {
                if (!store.state.permissions["Permissions.Reports.Create"]) {
                    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['AddReportTemplate'], false);//Disable toolbar items.
                }
                if (!store.state.permissions["Permissions.Reports.Update"]) {
                    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['EditReportTemplate'], false);//Disable toolbar items.
                }
                if (!store.state.permissions["Permissions.Reports.Delete"]) {
                    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['DeleteReportTemplate'], false);//Disable toolbar items.
                }
            },
            runReport: (args) => {
                showSpinner(document.getElementById('mainSpinner'));
                apis.protectedApi(`${urls.apiBaseUrl}ReportTemplate/runReport/${args.id}`).then(it => {
                    gridOptions.infoAlert("Report set to execute. When execution is done the report will be listed under available reports:" + args.name);
                    hideSpinner(document.getElementById('mainSpinner'));
                }
                ).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                        hideSpinner(document.getElementById('mainSpinner'));
                    }
                );
            },
            commandClick: function (args) {
                var templateId = args.rowData.id;
                if (args.commandColumn.buttonOption.content == "Run") {
                    this.runReport(args.rowData);
                }
            },

            toolbarClick(args) {
                if (args.item.id === 'AddReportTemplate') {
                    this.$router.push({ name: "Report Template Builder" });
                }
                if (args.item.id === 'EditReportTemplate') {
                    let selectedClient = this.$refs.grid.getSelectedRecords();
                    if (selectedClient.length > 0) {
                        this.$router.push({ name: "Report Template Builder", params: { templateId: selectedClient[0].id } });
                    } else {
                        DialogUtility.alert({
                            title: 'Alert Dialog',
                            content: "Please, choose a Report template first",
                            position: { X: 700, Y: 200 },
                            showCloseIcon: true,
                            closeOnEscape: true,
                            animationSettings: { effect: 'Zoom' },
                            zIndex: 1100
                        });
                    }
                }
                if (args.item.id === 'DeleteReportTemplate') {
                    let action = this.deleteReport;
                    AlertDialog = DialogUtility.alert({
                        title: 'Alert Dialog',
                        content: "Are you sure you want to delete this report template?",
                        position: { X: 700, Y: 200 },
                        okButton: { text: 'OK', click: action },
                        showCloseIcon: true,
                        closeOnEscape: true,
                        animationSettings: { effect: 'Zoom' },
                        zIndex: 1100
                    });
                }
                if (args.item.id.indexOf("excelexport") !== -1) {
                    gridOptions.excelExport(args, "Report Template.xlsx", this.$refs);
                }
            },
            deleteReport: function () {
                AlertDialog.hide();
                let selectedClient = this.$refs.grid.getSelectedRecords();
                if (selectedClient) {
                    apis.protectedApi.delete(`ReportTemplate/${selectedClient[0].id}`)
                        .then(response => {
                            let message = { title: 'Success!', content: 'Record is deleted successfully', cssClass: 'e-toast-success' };
                            this.$root.$emit('showToast', message);
                            this.$refs.grid.refresh();
                            AlertDialog.hide();
                        }).catch(e => {
                            DialogUtility.alert({
                                title: 'Alert Dialog',
                                content: e.response.data.message,
                                position: { X: 700, Y: 200 },
                                showCloseIcon: true,
                                closeOnEscape: true,
                                animationSettings: { effect: 'Zoom' },
                                zIndex: 1100
                            });
                        });
                }
            },
            recordDoubleClick: function (e) {
                this.$router.push({ name: "Report Template Builder", params: { templateId: e.rowData.id } });
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },

            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
            }
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading',

            });
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn]
        }
    };

</script>
<style>
</style>
